<template>
  <div class="filter-directory mb-5">
    <a class="collapsed d-flex background-white p-4 color-black align-items-center position-relative"
       data-toggle="collapse" href="#filter-points-mark" role="button" aria-expanded="true"
      :aria-controls="translate('hdShowFilters')">
      <i class="icon-card-related md mr-3"></i><span>{{translate('hdPointsToRedeem')}}</span>
      <i class="icon-arrow-up xxs"> </i>
    </a>
    <div class="position-relative">
      <div class="collapse show bg-color-alabaster px-5 pt-5 pb-2" id="filter-points-mark">
        <div class="row">
          <div class="col-lg-6">
            <vue-slider
              ref="slider"
              class="mt-4 mb-4 price-slider"
              @callback="$emit('change', { min: $event[0], max: $event[1] })"
              v-model="value"
              v-bind="sliderOptions"/>
          </div>
          <div class="w-100"></div>
          <div class="col-lg-6 d-flex justify-content-between">
            <span>{{ min | toPoints }}</span>
            <span>{{ max | toPoints }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  name: 'FilterPoints',
  components: {
    vueSlider
  },
  props: {
    max: Number,
    min: Number,
    selectedMin: Number,
    selectedMax: Number
  },
  computed: {
    value: {
      get () { return [this.selectedMin || this.min, this.selectedMax || this.max] },
      set () {}
    }
  },
  methods: {
    refresh () {
      this.$refs.slider.refresh()
    }
  },
  data: function () {
    return {
      sliderOptions: {
        min: this.min,
        max: this.max,
        lazy: true,
        formatter: value => this.formatPoints(value),
        tooltip: 'hover',
        width: '100%',
        height: 5,
        dotSize: 15,
        useKeyboard: true,
        enableCross: false,
        interval: 1,
        bgStyle: {
          backgroundColor: '#d8d8d8',
          boxShadow: 'rgba(0, 0, 0, 0) 0.5px 0.5px 3px 1px inset'
        },
        sliderStyle: [
          {
            backgroundColor: '#c20808'
          },
          {
            backgroundColor: '#c20808'
          }
        ],
        tooltipStyle: {
          backgroundColor: '#666',
          borderColor: '#666'
        },
        processStyle: {
          backgroundColor: '#c20808'
        }
      }
    }
  }
}
</script>

<style scoped>
  .label-up {
    left: 9px;
  }

  .form-group {
    float: initial;
  }

  .collapse.show {
    height: 100%;
    overflow: visible;
  }

  .filter-directory .icon-arrow-up {
    position: absolute;
    right: 15px;
  }

</style>
